<template>
  <el-form :model="form" ref="form">
    <el-row :gutter="20" class="m-2 border-bottom pb-6" >
    <!-- Cột 1: Thông tin cơ bản -->
      <el-col :xs="24" :sm="24" :md="8">
        <el-card shadow="never" style="border-top: 3px solid #00bfa5">
          <div slot="header"><b>Thông tin cơ bản</b></div>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Số điện thoại" prop="phone">
                <el-input v-model="form.phone" placeholder="Số điện thoại" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Họ tên" prop="name">
                <el-input v-model="form.name" placeholder="Họ tên" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Email" prop="email">
                <el-input v-model="form.email" placeholder="Email" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Facebook" prop="link_fb">
                <el-input v-model="form.link_fb" placeholder="Facebook" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Ngày sinh" prop="ngay_sinh">
                <el-date-picker
                    v-model="form.ngay_sinh"
                    type="date"
                    placeholder="Ngày sinh"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Quê quán" prop="que_quan">
                <el-input v-model="form.que_quan" placeholder="Quê quán" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Địa chỉ" prop="address">
                <el-input v-model="form.address" placeholder="Địa chỉ" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Trường học" prop="co_quan">
                <el-input v-model="form.co_quan" placeholder="Nhập trường học" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Ngành học" prop="nganh">
                <el-input v-model="form.nganh" placeholder="Nhập ngành học" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Đối tượng" prop="object_customer">
                <el-select v-model="form.object_customer" placeholder="Chọn đối tượng" style="width: 100%">
                  <el-option
                      v-for="item in objectCustomerDefine"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </el-col>

    <!-- Cột 2: Thông tin khách hàng tiềm năng -->
    <el-col :xs="24" :sm="24" :md="8">
      <el-card shadow="never" style="border-top: 3px solid #7e57c2">
        <div slot="header"><b>Thông tin khách hàng tiềm năng</b></div>
        <el-form-item label="Kênh" prop="nguon">
          <el-select v-model="form.nguon" placeholder="Chọn kênh" style="width: 100%">
            <el-option
                v-for="item in channels"
                :key="item.id"
                :label="item.value"
                :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Phím nóng" prop="phim_nong">
          <el-select
              class="w-100"
              v-model="form.hot_key"
              multiple
              collapse-tags
              placeholder="Chọn phím nóng"
              clearable
          >
            <el-option
                v-for="opt in phimNongDeFine"
                :key="opt.id"
                :label="opt.value"
                :value="opt.id"
            />
          </el-select>

        </el-form-item>

          <div
              v-for="id in form.hot_key"
              :key="id"
              class="mb-4"
          >
            <el-form-item
                :label="`Chi tiết: ${getHotKeyLabel(id)} *`"
                :prop="`hot_key_detail.${id}`"
            >
              <el-input
                  type="textarea"
                  v-model="form.hot_key_detail[id]"
                  :rows="4"
                  :placeholder="getHotKeyPlaceholder(id)"
              />
            </el-form-item>
          </div>

        <el-form-item label="Giải pháp mời hẹn">
          <el-input
              type="textarea"
              v-model="form.giai_phap_moi_hen"
              placeholder="Giải pháp mời hẹn của cấp trên"
          />
        </el-form-item>

        <el-form-item label="Ghi chú">
          <el-input type="textarea" v-model="form.note" placeholder="Ghi chú" />
        </el-form-item>
      </el-card>
    </el-col>

    <!-- Cột 3: Thông tin phụ huynh -->
    <el-col :xs="24" :sm="24" :md="8">
      <el-card shadow="never" style="border-top: 3px solid #ffb300">
        <div slot="header"><b>Thông tin phụ huynh</b></div>

        <el-form-item label="Họ tên">
          <el-input v-model="form.bo_me" placeholder="Họ tên" />
        </el-form-item>

        <el-form-item label="Số điện thoại">
          <el-input v-model="form.sdt_phu_huynh" placeholder="Số điện thoại" />
        </el-form-item>

        <el-form-item label="Quê quán">
          <el-input v-model="form.que_quan_phu_huynh" placeholder="Quê quán" />
        </el-form-item>

        <el-form-item label="Nghề nghiệp">
          <el-input v-model="form.nghe_nghiep_phu_huynh" placeholder="Nghề nghiệp" />
        </el-form-item>

        <el-form-item label="Ý kiến">
          <el-select v-model="form.y_kien_phu_huynh" placeholder="Chọn ý kiến" style="width: 100%">
            <el-option
                v-for="item in yKien"
                :key="item.id"
                :label="item.value"
                :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-card>
    </el-col>
  </el-row>
    <el-form-item class="mt-6 d-flex justify-content-end">
      <el-button :disabled="loading" type="primary" @click="onSubmit"> <i class="mr-1" :class="loading ? 'el-icon-loading' : 'el-icon-edit-outline'"></i>Ghi chú</el-button>
      <el-button @click="close()">Hủy</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import {CREATE_CUSTOMER_NOTE, UPDATE_CUSTOMER_NOTE} from "@/core/services/store/customer/customer.module";

export default {
  name: 'AddNoteCustomer',
  props: {
    customer: {
      type: Object,
      default: {},
    },

    isClear: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      form: {
        name: '',
        phone: '',
        email: '',
        ngay_sinh: '',
        nguon: '',
        object_customer: '',
        hot_key: [],
        hot_key_detail: {},
        note: '',
        giai_phap_moi_hen: '',
        nganh: '',
        address: '',
        co_quan: '',
        que_quan: '',
        link_fb: '',
        bo_me: '',
        sdt_phu_huynh: '',
        que_quan_phu_huynh: '',
        nghe_nghiep_phu_huynh: '',
        y_kien_phu_huynh: '',
      },
      parentOpinionOptions: [
        { id: 1, value: 'Đồng ý' },
        { id: 2, value: 'Cần thuyết phục' },
        { id: 3, value: 'Không đồng ý' },
      ],

      objectCustomerDefine: [
        { id: 1, value: "Học sinh" },
        { id: 2, value: "Sinh viên" },
        { id: 3, value: "Người đi làm" },
      ],

      phimNongDeFine: [
        { id: 1, value: "Tài chính", placeholder: "- Ai người quyết định chi trả tài chính?\n- Mức tài chính có phù hợp với gia đình không?\n- Mức tài chính có thể chi trả là bao nhiêu?" },
        { id: 2, value: "Phương pháp học", placeholder: "- Khách hàng lo ngại về hiệu quả phương pháp học?\n- Khách hàng cần thêm thông tin về phương pháp học?\n- Tại sao phải học tiếng anh?\n- Tại sao phải học tiếng Anh ở trung tâm này thay vì trung tâm khác?" },
        { id: 3, value: "Gia đình/Mối quan hệ", placeholder: "- Ai là người quyết định mua hàng?\n- Ai là người tác động, có tầm ảnh hưởng trong gia đình?\n- Khách hàng tin tưởng ai? (bạn bè, anh, chị, bố mẹ...)\n- Ý kiến phụ huynh?" },
        { id: 4, value: "Thời gian", placeholder: "- Khách hàng vướng lịch chưa học được? (VD: quân sự, chờ thi xong học, nghỉ hè...)\n- Tại sao phải học tiếng anh tại thời điểm này?" },
        { id: 5, value: "Định hướng học IELTS", placeholder: "- Khách hàng học IELTS để ra trường?\n- Khách hàng học IELTS để xin việc?\n- Kế hoạch ngắn hạn? dài hạn?" },
        { id: 6, value: "Quyết định và lựa chọn", placeholder: "- Khách hàng còn phân vân giữa các lựa chọn?\n- Tại sao chưa quyết định, cần thêm thuyết phục về điều gì?" },
        { id: 7, value: "Khoảng cách", placeholder: "- Khách hàng ở xa trung tâm? ...km?\n- Khách hàng lo lắng về vấn đề đi lại" },
        { id: 8, value: "Nỗi sợ", placeholder: "- Khách hàng không học được?\n- Sợ chi phí học cao?\n- Phân vân giữa học chứng chỉ/ngôn ngữ?" },
        { id: 9, value: "Khác", placeholder: "- Sở thích, Tính cách, Thói quen, Mong muốn" },
      ],

      channels: [
        { id: 'Nhân', value: 'Nhân' },
        { id: 'Nội bộ', value: 'Nội bộ' },
        { id: 'Ấm nóng', value: 'Ấm nóng' },
        { id: 'Tiếp xúc lạnh', value: 'Tiếp xúc lạnh' },
        { id: 'Liên kết trường', value: 'Liên kết trường' },
        { id: 'Lạnh', value: 'Lạnh' },
        { id: 'Facebook ads', value: 'Facebook ads' },
        { id: 'Google ads', value: 'Google ads' },
        { id: 'Tiktok ads', value: 'Tiktok ads' },
        { id: 'Vệ tinh', value: 'Vệ tinh' },
      ],

      yKien: [
        {id: '', value: "(Chọn ý kiến)"},
        {id: 'Chưa hỏi', value: 'Chưa hỏi'},
        {id: 'Đã hỏi - Không đồng ý', value: 'Đã hỏi - Không đồng ý'},
        {id: 'Đã hỏi - Đồng ý', value: 'Đã hỏi - Đồng ý'}
      ],
    };
  },

  watch: {
      customer: {
          handler(newVal) {
              if (newVal) {
                this.form = {
                      name: newVal.name || '',
                      phone: newVal.phone || '',
                      email: newVal.email || '',
                      ngay_sinh: newVal.ngay_sinh || '',
                      nguon: newVal.nguon || '',
                      object_customer: newVal.object_customer || '',
                      hot_key:newVal.hot_key || [],
                      hot_key_detail: newVal.hot_key_detail || {},
                      note: newVal.note || '',
                      giai_phap_moi_hen: newVal.giai_phap_moi_hen || '',
                      nganh: newVal.nganh || '',
                      address: newVal.address || '',
                      que_quan: newVal.que_quan || '',
                      link_fb: newVal.link_fb || '',
                      bo_me: newVal.bo_me || '',
                      co_quan: newVal.co_quan || '',
                      sdt_phu_huynh: newVal.sdt_phu_huynh || '',
                      que_quan_phu_huynh: newVal.que_quan_phu_huynh || '',
                      nghe_nghiep_phu_huynh: newVal.nghe_nghiep_phu_huynh || '',
                      y_kien_phu_huynh: newVal.y_kien_phu_huynh || '',
                  };
              }else {
                this.clearForm();
              }
          },
          immediate: true,
      },
  },
  methods: {
      async onSubmit() {
          const isCancel = this.checkValidator();
          if (!isCancel) return;
          try {
              this.loading = true;
              if (this.customer) {
                  this.form.id = this.customer.id;
                  const res = await this.$store.dispatch(UPDATE_CUSTOMER_NOTE, this.form);
                  if (!res.error) {
                    this.$notify({
                          title: 'Success',
                          message: res.message ?? 'Update ghi chú thành công',
                          type: 'success',
                      });
                      this.clearForm();
                      this.$emit('close');
                      this.$emit('reload');
                  }
              } else {
                  await this.create();
              }
          } catch (error) {
              this.$notify({
                  title: 'Lỗi',
                  message: error?.data.message ?? 'Đã xảy ra lỗi khi lưu ghi chú',
                  type: 'error',
              });
          } finally {
              this.loading = false;
          }
      },

    create() {
      this.loading = true;
      this.$store.dispatch(CREATE_CUSTOMER_NOTE, this.form)
          .then((res) => {
            this.clearForm();
            this.$emit('close');
            this.$emit('reload');
            this.$notify({
              title: 'Thành công',
              message: res.message ?? 'Thành công!',
              type: 'success',
            });
          })
          .catch((error) => {
            this.$notify({
              title: 'Lỗi',
              message: error?.data.message ?? 'Đã xảy ra lỗi khi tạo ghi chú',
              type: 'error',
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },

    clearForm() {
      this.form = {
        name: '',
        phone: '',
        email: '',
        ngay_sinh: '',
        nguon: '',
        object_customer: '',
        hot_key: [],
        hot_key_detail: {},
        note: '',
        giai_phap_moi_hen: '',
        nganh: '',
        address: '',
        que_quan: '',
        link_fb: '',
        bo_me: '',
        sdt_phu_huynh: '',
        que_quan_phu_huynh: '',
        nghe_nghiep_phu_huynh: '',
        y_kien_phu_huynh: '',
      };
    },

    checkValidator() {
         const phoneRegex = /^(0|\+84)[0-9]{9,10}$/;
         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

         if (!phoneRegex.test(this.form.phone) && this.form.phone) {
           this.$message.error('Số điện thoại không hợp lệ');
           this.form.phone = '';
           this.loading = false;
           return false;
         }

         if (this.form.hot_key.length > 0) {
           for (const id of this.form.hot_key) {
             if (!this.form?.hot_key_detail[id] || !this.form?.hot_key_detail[id].trim()) {
               this.$message.error(`Vui lòng nhập chi tiết cho phím nóng: ${this.getHotKeyLabel(id)}`);
               this.loading = false;
               return false;
             }
           }
         }

         if (this.form.email && !emailRegex.test(this.form.email)) {
           this.$message.error('Email không hợp lệ');
           this.form.phone = '';
           this.loading = false;
           return false;
         }

         return true;
    },
    close() {
      this.$emit('close');
    },
    getHotKeyLabel(id) {
      const item = this.phimNongDeFine.find(i => i.id === id);
      return item ? item.value : '';
    },
    getHotKeyPlaceholder(id) {
      const item = this.phimNongDeFine.find(i => i.id === id);
      return item ? item.placeholder : '';
    },
  },
};
</script>

<style scoped>
</style>
